import { IAnalyticRubricCriterion } from '@/components/staffer/ExerciseBuilder/Rubric/useQuestionRubric';
import React, { useState } from 'react';
import Froala from '@/components/shared/Froala';
import cn from '@/utils/cn';
import I18n from 'i18n-js';
import styles from './AnalyticRubric.module.scss';

export type EditorDescriptionCellProps = {
  criterionData: IAnalyticRubricCriterion;
  locale?: Lowercase<Locale>;
  onLevelDescriptionChange: (criterionIndex: number, score: number, newDescription: string) => void;
  rowIndex: number;
  score: number;
};

const EditorLevelDescriptionCell = ({
  criterionData,
  locale,
  onLevelDescriptionChange,
  rowIndex,
  score,
}: EditorDescriptionCellProps) => {
  const level = criterionData.levels.find(l => l.score === score);
  const description = locale === 'en' ? (level?.description_en ?? '') : (level?.description_es ?? '');
  const [isToolbarVisible, setIsToolbarVisible] = useState(false);

  return (
    <>
      <Froala
        customConfig={{
          charCounterCount: false,
          height: 80,
          pastePlain: true,
          placeholderText: I18n.t('enter_text', { locale }),
          toolbarButtons: [
            ['bold', 'italic', 'underline', 'formatUL', 'clearFormatting'],
          ],
          toolbarContainer: `#toolbar-container-${score}-${rowIndex}`,
          width: 'auto',
        }}
        eventHandlers={[
          { blur: () => setIsToolbarVisible(false) },
          { focus: () => setIsToolbarVisible(true) },
        ]}
        modelType="RubricDescription"
        name={`description-${score}-${rowIndex}`}
        text={description}
        userType="Admin"
        onChange={newDescription => onLevelDescriptionChange(rowIndex, score, newDescription)}
      />
      <div
        className={
          cn(styles.analyticToolbarContainer,
            'tw-absolute -tw-top-[52px] tw-left-1/2 tw--translate-x-1/2 tw-w-64',
            { 'tw-hidden': !isToolbarVisible })}
        id={`toolbar-container-${score}-${rowIndex}`}
      />
    </>
  );
};

export default EditorLevelDescriptionCell;
